import { render, staticRenderFns } from "./BookingsSingleTable.vue?vue&type=template&id=7b2122ca&scoped=true"
import script from "./BookingsSingleTable.vue?vue&type=script&lang=js"
export * from "./BookingsSingleTable.vue?vue&type=script&lang=js"
import style0 from "./BookingsSingleTable.vue?vue&type=style&index=0&id=7b2122ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2122ca",
  null
  
)

export default component.exports